"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormToolField = void 0;
var FormToolField;
(function (FormToolField) {
    FormToolField[FormToolField["Salutation"] = 1] = "Salutation";
    FormToolField[FormToolField["Title"] = 2] = "Title";
    FormToolField[FormToolField["Function"] = 3] = "Function";
    FormToolField[FormToolField["FirstName"] = 4] = "FirstName";
    FormToolField[FormToolField["LastName"] = 5] = "LastName";
    FormToolField[FormToolField["Company"] = 6] = "Company";
    FormToolField[FormToolField["Department"] = 7] = "Department";
    FormToolField[FormToolField["Speciality"] = 8] = "Speciality";
    FormToolField[FormToolField["Street"] = 9] = "Street";
    FormToolField[FormToolField["PostalCode"] = 10] = "PostalCode";
    FormToolField[FormToolField["City"] = 11] = "City";
    FormToolField[FormToolField["Country"] = 12] = "Country";
    FormToolField[FormToolField["TelephoneNumber"] = 13] = "TelephoneNumber";
    FormToolField[FormToolField["Email"] = 14] = "Email";
    FormToolField[FormToolField["DeliveryFirstName"] = 15] = "DeliveryFirstName";
    FormToolField[FormToolField["DeliveryLastName"] = 16] = "DeliveryLastName";
    FormToolField[FormToolField["DeliveryTitle"] = 17] = "DeliveryTitle";
    FormToolField[FormToolField["DeliverySalutation"] = 18] = "DeliverySalutation";
    FormToolField[FormToolField["DeliveryCompany"] = 19] = "DeliveryCompany";
    FormToolField[FormToolField["DeliveryStreet"] = 20] = "DeliveryStreet";
    FormToolField[FormToolField["DeliveryPostalCode"] = 21] = "DeliveryPostalCode";
    FormToolField[FormToolField["DeliveryCity"] = 22] = "DeliveryCity";
    FormToolField[FormToolField["DeliveryCountry"] = 23] = "DeliveryCountry";
    FormToolField[FormToolField["DeliveryEmail"] = 24] = "DeliveryEmail";
    FormToolField[FormToolField["Option1"] = 25] = "Option1";
    FormToolField[FormToolField["Option2"] = 26] = "Option2";
    FormToolField[FormToolField["Option3"] = 27] = "Option3";
    FormToolField[FormToolField["Option4"] = 28] = "Option4";
    FormToolField[FormToolField["Option5"] = 29] = "Option5";
    FormToolField[FormToolField["Option6"] = 30] = "Option6";
    FormToolField[FormToolField["Option7"] = 31] = "Option7";
    FormToolField[FormToolField["Option8"] = 32] = "Option8";
    FormToolField[FormToolField["Option9"] = 33] = "Option9";
    FormToolField[FormToolField["Option10"] = 34] = "Option10";
    FormToolField[FormToolField["Option11"] = 35] = "Option11";
    FormToolField[FormToolField["Option12"] = 36] = "Option12";
    FormToolField[FormToolField["Option13"] = 37] = "Option13";
    FormToolField[FormToolField["Option14"] = 38] = "Option14";
    FormToolField[FormToolField["Option15"] = 39] = "Option15";
    FormToolField[FormToolField["Option16"] = 40] = "Option16";
    FormToolField[FormToolField["Option17"] = 41] = "Option17";
    FormToolField[FormToolField["Option18"] = 42] = "Option18";
    FormToolField[FormToolField["Option19"] = 43] = "Option19";
    FormToolField[FormToolField["Option20"] = 44] = "Option20";
    FormToolField[FormToolField["Profession"] = 45] = "Profession";
    FormToolField[FormToolField["DeliveryCompany2"] = 46] = "DeliveryCompany2";
    FormToolField[FormToolField["DeliveryActive"] = 47] = "DeliveryActive";
    FormToolField[FormToolField["Option21"] = 48] = "Option21";
    FormToolField[FormToolField["Option22"] = 49] = "Option22";
    FormToolField[FormToolField["Option23"] = 50] = "Option23";
    FormToolField[FormToolField["Option24"] = 51] = "Option24";
    FormToolField[FormToolField["Option25"] = 52] = "Option25";
})(FormToolField = exports.FormToolField || (exports.FormToolField = {}));
